import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from '../common/interface';

@Injectable({
  providedIn: 'root'
})
export class MeetingService {

  constructor(
    private http : HttpClient
  ) { }

  getMeetings(status, solicitorId){
    let params : HttpParams = new HttpParams().set('status', status).set('solicitorId', solicitorId);
    return this.http.get<response>(environment.url + "meetings", {params : params});
  }

  getMeeting(id){
    let params: HttpParams = new HttpParams().set('id', id);
    return this.http.get<response>(environment.url + "meeting", {params : params});
  }

  saveMeeting(data){
    return this.http.post<response>(environment.url + "meetings", data);
  }

  saveAgendas(data){
    return this.http.post<response>(environment.url + "meetings/agendas", data);
  }

  updateAgendas(id, data){
    return this.http.put<response>(environment.url + "meetings/agendas/"+id, data);
  }

  updateMeeting(id, data){
    return this.http.put<response>(environment.url + "meeting/"+id, data);
  }

  deleteMeeting(id){
    return this.http.delete<response>(environment.url + "meeting/"+id);
  }

}
